<template>
  <div class="deliver">
    <!-- <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ title }}</span>
      <span></span>
    </header> -->
    <section>
      <van-tabs v-model="moduleType" @click="onModuleClick">
        <van-tab title="BBK" :name="1"></van-tab>
        <van-tab title="LCL" :name="2"></van-tab>
        <van-tab title="FCL" :name="3"></van-tab>
      </van-tabs>
      <section class="padding">
        <div class="card round" v-show="moduleType <= 2">
          <ul class="list">
            <li class="list-item flexbox header">
              <van-checkbox
                v-model="checkAll"
                @change="onCheckAll"
              ></van-checkbox>
              <div class="flex-fill min-col-30 title">
                {{ $t('Deliver.vdo6nj') }}
              </div>
              <div class="flex-fill min-col-30 title">
                {{ $t('Deliver.zwrdal') }}
              </div>
              <div class="flex-fill min-col-10 title">
                {{ $t('Deliver.总货值') }}
              </div>
              <div class="flex-fill min-col-10 title">
                {{ $t('Deliver.箱数') }}
              </div>
            </li>
            <li
              class="list-item flexbox"
              v-for="item in packageList"
              :key="item.id"
            >
              <van-checkbox
                v-model="item.checked"
                @change="doItemCheck($event, item)"
              ></van-checkbox>
              <div class="flex-fill min-col-30">
                {{ item.delivery_no }}
              </div>
              <div class="flex-fill min-col-30">
                {{ item.goods_name }}
              </div>
              <div class="flex-fill min-col-10">
                {{ item.fTotalDeclarePrice }}
              </div>
              <div class="flex-fill min-col-10">{{ item.iBags }}</div>
            </li>
          </ul>
          <footer class="flexbox align-center space-bt">
            <div class="f-12">
              {{ $t('显示第') }} {{ (pageIndex - 1) * pageSize + 1 }}
              {{ $t('到第')
              }}{{
                (pageIndex - 1) * pageSize + pageSize > total
                  ? total
                  : (pageIndex - 1) * pageSize + pageSize
              }}
              {{ $t('条记录') }}，{{ $t('总共') }} {{ total }} {{ $t('条') }}
            </div>
            <van-pagination
              v-model="pageIndex"
              prev-text=" "
              next-text=" "
              :total-items="total"
              :items-per-page="pageSize"
              @change="doChangePackageList"
            />
          </footer>
        </div>
        <div class="card round" v-show="moduleType == 3">
          <van-field v-model="sender.name" :label="$t('寄件人')"></van-field>
          <van-field v-model="sender.tel" :label="$t('电话')"></van-field>
        </div>

        <div
          class="card address flexbox align-center round"
          v-show="moduleType <= 2"
        >
          <div class="tag receiver">{{ $t('收') }}</div>
          <div class="flex-fill">
            <div class="flexbox">
              <span>{{ receiver.name || $t('请选择') }}</span>
              <span>{{ receiver.tel }}</span>
            </div>
            <address class="f-12">{{ receiver.address }}</address>
          </div>
          <div
            class="btn-pick"
            @click="
              $router.push({
                name: 'AddressList',
                query: { owner: 'receiver' },
              })
            "
          >
            {{ $t('选择') }}
          </div>
        </div>
      </section>
      <ul class="props">
        <li class="list-item flexbox" v-show="moduleType <= 0">
          <span class="label">{{ $t('Deliver.专线选择') }}</span>
          <div
            @click="showLinePicker = true"
            class="ml-auto"
            :class="{ 'color-3': distLineText }"
          >
            {{ distLineText || $t('点击选择发货专线') }}
          </div>
        </li>
        <li class="list-item flexbox" v-show="moduleType <= 2">
          <span class="label">{{ $t('业务类型') }}</span>
          <van-radio-group
            v-model="bizTypeId"
            class="flex-fill"
            direction="horizontal"
          >
            <van-radio
              v-for="item in bizTypeList"
              :key="item.value"
              :name="item.value"
              class="option"
              >{{ item.name }}</van-radio
            >
          </van-radio-group>
        </li>
        <li class="list-item flexbox" v-show="moduleType <= 2">
          <span class="label">{{ $t('Deliver.124niu') }}</span>
          <van-radio-group
            v-model="packageType"
            class="flex-fill"
            direction="horizontal"
          >
            <van-radio
              v-for="item in packageTypeList"
              :key="item.value"
              :name="item.value"
              class="option"
              >{{ item.name }}</van-radio
            >
          </van-radio-group>
        </li>
        <li class="list-item flexbox" >
          <span class="label">{{ $t('Deliver.m2lxd9') }}</span>
          <van-radio-group
            v-model="transType"
            @change="onLoadPortStationList"
            class="flex-fill"
            direction="horizontal"
            :disabled="selectedLineId > 0"
          >
            <van-radio
              v-for="item in transTypeList"
              :key="item.value"
              :name="item.value"
              class="option"
              >{{ item.name }}</van-radio
            >
          </van-radio-group>
        </li>
        <li class="list-item flexbox" v-show="moduleType <= 0">
          <span class="label">{{ $t('Deliver.ttotwd') }}</span>
          <div
            @click="showPicker = selectedLineId <= 0 ? true : false"
            class="ml-auto"
            :class="{ 'color-3': destinationText }"
          >
            {{ destinationText || $t('点击选择目的地') }}
          </div>
        </li>
        <li class="list-item flexbox">
          <span class="label">{{ $t('POL') }}</span>
          <el-select
            v-model="pol"
            style="width: 100%;"
            filterable
            size="small"
            placeholder="请选择POL"
          >
            <el-option
              v-for="item in portStationOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li>

        <li class="list-item flexbox">
          <span class="label">{{ $t('POD') }}</span>
          <el-select
            v-model="pod"
            style="width: 100%;"
            filterable
            size="small"
            placeholder="请选择POD"
          >
            <el-option
              v-for="item in portStationOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li>
        <li class="list-item flexbox" v-if="moduleType == 3">
          <span class="label">{{ $t('柜型') }}</span>
          <el-select
            v-model="ctnType"
            filterable
            style="width: 100%;"
            size="small"
            placeholder="请选择CONTAINER TYPE"
          >
            <el-option
              v-for="item in ctnTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li>
        <li class="list-item flexbox" v-if="moduleType == 3">
          <span class="label">{{ $t('柜号') }}</span>
          <van-field v-model="ctnNo" :placeholder="$t('请填写柜号,CTN NO')" />
        </li>
        <li class="list-item flexbox" v-if="moduleType == 3">
          <span class="label">{{ $t('提取空箱') }}</span>
          <van-field v-model="emptyDropOff" :placeholder="$t('提取空箱')" />
        </li>
        <li class="list-item flexbox">
          <span class="label">{{ $t('签收人') }}</span>
        </li>
        <li class="list-item">
          <van-field
            v-model="consignee"
            rows="2"
            type="textarea"
            class="border"
            :placeholder="$t('请填写签收人信息,CONSIGNEE')"
            show-word-limit
          />
        </li>
        <li class="list-item flexbox" v-if="moduleType == 3">
          <span class="label">{{ $t('通知人') }}</span>
        </li>
        <li class="list-item" v-if="moduleType == 3">
          <van-field
            v-model="notifier"
            rows="2"
            type="textarea"
            class="border"
            :placeholder="$t('请填写通知人,NOTIFIER')"
            show-word-limit
          />
        </li>
        <li class="list-item flexbox" v-if="moduleType <= 2">
          <span class="label">{{ $t('总重量') }}</span>
          <van-field
            type="number"
            digits="2"
            v-model="totalWeight"
            :placeholder="$t('请填写总重量')"
            class="qs-mb"
          ></van-field>
        </li>
        <li class="list-item flexbox hidden" v-if="moduleType <= 2">
          <span class="label">{{ $t('总体积') }}</span>
          <van-field
            type="number"
            digits="2"
            v-model="totalVolume"
            :placeholder="$t('请填写总体积')"
            class="qs-mb"
          ></van-field>
        </li>
        <li class="list-item flexbox" v-if="moduleType <= 2">
          <span class="label">{{ $t('Deliver.d2rdz7') }}</span>
        </li>
        <li class="list-item" v-if="moduleType <= 2">
          <van-field
            v-model="goodsName"
            rows="2"
            type="textarea"
            class="border"
            :placeholder="$t('请填写货物名称')"
            show-word-limit
          />
        </li>
        <li class="list-item flexbox" v-if="moduleType == 3">
          <span class="label">{{ $t('ARRANGEMENT') }}</span>
        </li>
        <li class="list-item">
          <van-field
            v-model="note"
            rows="2"
            type="textarea"
            class="border"
            :placeholder="$t('Deliver.6drhhq')"
            show-word-limit
          />
        </li>
      </ul>
      <div class="footer-btn">
        <van-button type="info" @click="onSubmit">{{
          $t('Deliver.0n2ao8')
        }}</van-button>
      </div>
    </section>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showLinePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="lineList"
        @confirm="onLineSelected"
        @cancel="showLinePicker = false"
      />
    </van-popup>
    <van-popup v-model="showStartPortPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="portStationOptions.map(item => item.name)"
        @confirm="onStartPortSelected"
        @cancel="showStartPortPicker = false"
      />
    </van-popup>
    <van-popup v-model="showTargetPortPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="portStationOptions.map(item => item.name)"
        @confirm="onTargetPortSelected"
        @cancel="showTargetPortPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  getPackageList,
  submitOrder,
  submitTranditionOrder,
  getCommonItemList,
  getLineList,
  getPortStationList,
} from '@/api/deliver.js';
import { $t } from '@/plugins/i18n';

export default {
  name: 'Deliver',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'AddressList') {
        vm[from.query.owner] = from.query;
      }
    });
  },
  data() {
    return {
      moduleType: 3,
      active: 0,
      checkAll: false,
      pageIndex: 1,
      pageSize: 100,
      total: 0,
      goodsName: '',
      title: 'LSD FCL',
      transType: 0,
      packageType: 0,
      bizTypeId: 0,
      bizTypeList: [],
      packageTypeList: [],
      transTypeList: [],
      note: '',
      datasource: [],
      sender: {
        name: '',
        tel: '',
        address: '',
      },
      receiver: {
        name: '',
        tel: '',
        address: '',
      },
      showPicker: false,
      destinationText: '',
      destinationOptions: [],
      checkedPackagesList: [],
      lineOptions: [],
      showLinePicker: false,
      distLineText: '',
      selectedLineId: -1, //增加专线ID
      pod: '',
      pol: '',
      ctnNo: '',
      ctnType: '',
      emptyDropOff: '',
      consignee: '',
      notifier: '',
      totalWeight: '',
      totalVolume: '',
      portStationOptions: [],
      showStartPortPicker: false,
      showTargetPortPicker: false,
      startPortText: '',
      targetPortText: '',
      ctnTypeOptions: [
        {
          name: '20GP',
          value: '20GP',
        },
        {
          name: '20HQ',
          value: '20HQ',
        },
        {
          name: '40GP',
          value: '40GP',
        },
        {
          name: '40HQ',
          value: '40HQ',
        },
        {
          name: '45HQ',
          value: '45HQ',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    columns() {
      return this.destinationOptions.map(item => item.name);
    },
    lineList() {
      return this.lineOptions.map(item => item.name);
    },
    packageList() {
      return this.datasource;
      // return this.datasource.slice(
      //   (this.pageIndex - 1) * this.pageSize,
      //   this.pageIndex * this.pageSize
      // );
    },
  },
  watch: {
    userInfo: {
      handler(value) {
        if (value && value.PK_ID) {
          this.sender.name = value.name;
          this.sender.tel = value.tel;
        } else {
          this.$store.dispatch('getUserInfo');
        }
      },
      immediate: true,
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      getPackageList({
        state: 0,
        limit: this.pageSize,
        offset: this.pageIndex - 1,
      }).then(res => {
        this.datasource = res.rows.map(item => {
          return {
            ...item,
            checked: false,
          };
        });

        this.total = res.total;
      });

      getLineList({
        keyword: '',
        status: '',
      }).then(res => {
        if (res.Result == true) {
          this.lineOptions = res.DataDict['list'].map(item => {
            return {
              name: item.sName,
              value: item.PK_ID,
              targetPlaceId: item.FK_EndPlaceID,
              targetPlaceName: item.sTargetPlace,
              transTypeId: item.FK_TransWayID,
              transTypeName: item.sTransWay,
            };
          });
          //专线选额默认，默认不启用
          // this.onLineSelected(this.lineOptions[0].value, 0);
        }
      });

      //目的地
      getCommonItemList('007').then(res => {
        this.destinationOptions = res.map(item => {
          return {
            name: item.text,
            value: item.value,
          };
        });
      });
      //业务类型
      getCommonItemList('010').then(res => {
        this.bizTypeList = res.map(item => {
          return {
            name: item.text,
            value: item.value,
          };
        });
        this.bizTypeId = this.bizTypeList[0].value;
      });

      //货物类型，敏感货，普货
      getCommonItemList('008').then(res => {
        this.packageTypeList = res.map(item => {
          return {
            name: item.text,
            value: item.value,
          };
        });
        this.packageType = this.packageTypeList[0].value;
      });
      //运输方式
      getCommonItemList('002').then(res => {
        this.transTypeList = res.map(item => {
          return {
            name: item.text,
            value: item.value,
          };
        });
        this.transType = this.transTypeList[0].value;
      });
    },
    onTargetPortSelected(value, index) {
      this.pod = this.portStationOptions[index].value;
      this.targetPortText = this.portStationOptions[index].name;
      this.showTargetPortPicker = false;
    },
    onStartPortSelected(value, index) {
      this.pol = this.portStationOptions[index].value;
      this.startPortText = this.portStationOptions[index].name;
      this.showStartPortPicker = false;
    },

    //翻页
    doChangePackageList() {
      getPackageList({
        state: 0,
        limit: this.pageSize,
        offset: (this.pageIndex - 1) * this.pageSize,
      }).then(res => {
        this.datasource = res.rows.map(item => {
          return {
            ...item,
            checked: false,
          };
        });
        this.total = res.total;
        //原有的所有的临时数据
        let tmp_pkglist = [];
        this.checkedPackagesList.forEach(it => {
          tmp_pkglist.push(it);
        });
        //取消了临时数据
        this.checkAll = false;
        console.log(tmp_pkglist);
        setTimeout(() => {
          //做已选择的匹配
          tmp_pkglist.forEach(item => {
            var existarr = this.packageList.filter(el => el.PK_ID == item);
            if (existarr != null && existarr.length > 0) {
              existarr[0].checked = true;
            } else {
              var chkarr = this.checkedPackagesList.filter(el => el == item);
              if (chkarr == null || chkarr.length == 0) {
                this.checkedPackagesList.push(item);
              }
            }
          });
        }, 100);
        // this.packageList.forEach(item => {
        //   var existarr = tmp_pkglist.filter(el => el == item.PK_ID);
        //   if (existarr != null && existarr.length > 0) {
        //     item.checked = true;
        //   }
        // });
        // var checklist = this.packageList.filter(el => el.checked == true);
        // if (checklist != null && checklist.length == this.packageList.length) {
        //   this.checkAll = true;
        // }
      });
    },

    //单个单个选中的操作函数
    doItemCheck($event, item) {
      if (item.checked == true) {
        //选中
        var existarr = this.checkedPackagesList.filter(el => el == item.PK_ID);
        if (existarr == null || existarr.length == 0) {
          this.checkedPackagesList.push(item.PK_ID);
        }
      } else {
        this.checkedPackagesList = this.checkedPackagesList.filter(
          el => el != item.PK_ID
        );
      }

      // var checklist = this.packageList.filter(el => el.checked == true);
      // if (checklist != null && checklist.length == this.packageList.length) {
      //   this.checkAll = true;
      // }

      console.log(this.checkedPackagesList);
      this.totalWeight = 0;
      this.totalVolume = 0;
      this.datasource.forEach(item => {
        let wei = item.fTotalWeight ?? 0;
        let vol = item.fVol ?? 0;
        this.totalWeight += wei;
        this.totalVolume += vol;
      });
      this.totalWeight = this.totalWeight.toFixed(2);
      this.totalVolume = this.totalVolume.toFixed(2);
    },

    onLineSelected(value, index) {
      //选择专线
      this.selectedLineId = value;
      this.selectedLineId = this.lineOptions[index].value;
      this.distLineText = this.lineOptions[index].name;
      this.showLinePicker = false;
      //根据选择的专线，设置对应的目的地，运输方式

      this.destination = this.lineOptions[index].targetPlaceId;
      this.destinationText = this.lineOptions[index].targetPlaceName;
      this.transType = this.lineOptions[index].transTypeId;
    },
    onCheckAll(value) {
      //取消全选,全选
      this.packageList.forEach(item => {
        item.checked = value;
      });
    },
    onConfirm(value, index) {
      this.destination = this.destinationOptions[index].value;
      this.destinationText = this.destinationOptions[index].name;
      this.showPicker = false;
    },
    onModuleClick() {
      if (this.moduleType == 3) {
        this.title = 'LSD FCL';
        this.bizTypeId = 3065;
      } else if (this.moduleType == 2) {
        this.title = 'LSD LCL';
        this.bizTypeId = 1029;
      } else if (this.moduleType == 1) {
        this.title = 'LSD BBK';
        this.bizTypeId = 1028;
      }
    },
    onLoadPortStationList() {
      this.portStationOptions = [];
      //1机场，2，海运港口,3.车站，4.火车站
      //alert(this.transType);
      let dict = { 3: 3, 5: 2, 4: 1, 3073: 4 };
      let typeId = dict[this.transType];
      getPortStationList(typeId).then(res => {
        //console.log(res);
        if (res.Result == false) {
          //this.$toast.fail(res.Info);
          return;
        }
        this.portStationOptions = res.DataDict['list'].map(item => {
          return {
            name: `[${item.sCode}]${item.sName}`,
            value: item.PK_ID,
          };
        });
        //console.log(this.portStationOptions);
      });
    },

    reset() {
      this.loadData();
      this.receiver = {};
      this.note = '';
      this.packageType = this.packageTypeList[0].value;
      this.transType = this.transTypeList[0].value;
      this.onCheckAll(false);
      this.checkAll = false;
    },
    onSubmit() {
      //专线，集运，传统
      if (this.moduleType <= 0) {
        if (this.selectedLineId <= 0) {
          this.$toast($t('请选择专线'));
          return;
        }
        if (this.checkedPackagesList.filter(item => item > 0).length === 0) {
          this.$toast($t('请选择包裹'));
          return;
        }
        if (!this.receiver.name) {
          this.$toast($t('请选择收件人'));
          return;
        }
        if (!this.destination) {
          this.$toast($t('请选择目的地'));
          return;
        }
        this.$toast.loading({ duration: 0 });
        submitOrder({
          destination: this.destination,
          transportType: this.transType,
          sender: this.sender.name,
          senderTel: this.sender.tel,
          name: this.goodsName,
          type: this.packageType,
          receiverId: this.receiver.id,
          remark: this.note,
          lineId: this.selectedLineId,
          packageIds: this.checkedPackagesList.map(item => item),
        })
          .then(res => {
            if (res.Result) {
              this.$toast(res.Info);
              this.reset();
            } else {
              this.$toast.fail(res.Info);
            }
          })
          .catch(() => {
            this.$toast.clear();
          });
      } else  {
        //传统订单
        submitTranditionOrder({
          startPlaceId: this.pol,
          targetPlaceId: this.pod,
          transTypeId: this.transType,
          bizTypeId: this.bizTypeId,
          senseId: this.packageType,
          sender: this.sender.name,
          senderTel: this.sender.tel,
          consignee: this.consignee,
          notifier: this.notifier,
          goodsName: this.goodsName,
          goodsWeight: this.totalWeight,
          goodsVolume: this.totalVolume,
          remark: this.note,
          ctnNo: this.ctnNo,
          ctnType: this.ctnType,
          emptyDropOff: this.emptyDropOff,
          packageIds: this.checkedPackagesList.map(item => item),
        }).then(res => {
          if (res.Result) {
            this.$toast(res.Info);
            this.reset();
            setTimeout(() => {
              this.$router.push({
                name: 'OrderListProcessing',
                query: {
                  status: 0,
                  type: 'order',
                },
              });
            }, 2000);
          } else {
            this.$toast.fail(res.Info);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.deliver {
  color: #333;
  margin-bottom: rem(20px);
}
.padding {
  padding: rem(20px);
}
.header .title {
  font-size: rem(24px);
}
.min-col-30 {
  min-width: 30%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: rem(22px);
  padding-right: 3px;
}
.min-col-20 {
  min-width: 20%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: rem(22px);
  padding-right: 3px;
}
.min-col-10 {
  min-width: 10%;
  font-size: rem(22px);
  text-align: center;
}
.card {
  box-shadow: 0px 2px 10px 10px rgba(14, 48, 53, 0.1);
  & + .card {
    margin-top: rem(20px);
  }
  background-color: #fff;
  &.address {
    padding: rem(20px);
  }
  .list {
    max-height: 300px;
    overflow-y: auto;
  }
}
.van-checkbox {
  margin-right: rem(30px);
}
.list-item {
  padding: rem(20px);
  border-bottom: 1px solid #e6e6e6;
  .label {
    width: 70px;
  }
  &.header {
    background-color: #9c9bb4;
    color: #fff;
    border-top-left-radius: rem(15px);
    border-top-right-radius: rem(15px);
  }
}
footer {
  color: #b8b8b8;
  padding: 0 rem(20px);
}
/deep/ .van-pagination__item {
  color: inherit;
  background-color: transparent;
  &::after {
    border-width: 0;
  }
}
/deep/ .van-pagination__item--active {
  background-color: transparent;
  color: $theme-color;
}
.tag {
  width: rem(60px);
  height: rem(60px);
  line-height: rem(60px);
  text-align: center;
  color: #fff;
  border-radius: rem(10px);
  margin-right: rem(20px);
  font-size: 20px;
  &.sender {
    background-color: $theme-color;
  }
  &.receiver {
    background-color: #f48f0d;
  }
}
address {
  font-style: normal;
  line-height: 1.5;
  margin-top: rem(24px);
  color: #9c9bb4;
}
.btn-pick {
  color: $theme-color;
  margin-left: rem(70px);
  margin-right: rem(20px);
  white-space: nowrap;
}
.option {
  border-radius: rem(15px);
  height: rem(40px);
  line-height: rem(40px);
  border: 1px solid #b8b8b8;
  // flex: 1;x
  display: block;
  text-align: center;
  padding-left: 3px;
  padding-right: 11px;
  margin-bottom: 3px;
  margin-right: 5px;
  & + .option {
    margin-left: rem(10px);
  }
  &[aria-checked='true'] {
    border-color: $theme-color;
    color: $theme-color;
  }
}
.props {
  background-color: #fff;
  color: #b8b8b8;
  .label {
    margin-right: rem(50px);
    white-space: nowrap;
  }
}
// .van-cell {
//   padding-top: 0;
//   padding-bottom: 0;
// }
/deep/ .van-radio__label {
  color: inherit;
}
/deep/ .van-radio__icon {
  display: none;
}
.van-field {
  &.border {
    border: 1px solid #b8b8b8;
    border-radius: rem(15px);
  }
}
.qs-mb {
  padding: 0;
  padding-left: 15px;
}
.footer-btn {
  margin: rem(24px);
  text-align: center;
  .van-button {
    width: 80%;
  }
}
</style>
